export default function Divider({ classNames }: { classNames: string }) {
  return <div className={`hidden sm:flex border-t-2 ${classNames}`}></div>;
}
